import * as React from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import { genURL } from "../../_getjson";
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import CustomInput from "../../Components/CustomInput/CustomInput";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../assets/jss/psstyle/psacount";
const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "code",
    headerName: "รหัสลูกค้า",
    width: 150,
    editable: false,
  },
  {
    field: "arname",
    headerName: "ชื่อลูกค้า",
    width: 200,
    editable: false,
  },
  {
    field: "addressth",
    headerName: "ที่อยู่",
    width: 300,
    editable: false,
  },
  {
    field: "contactname",
    headerName: "ผู้ติดต่อ",
    width: 110,
    editable: false,
  },
  {
    field: "telephone",
    headerName: "โทรศัพท์",
    width: 110,
    editable: false,
  },
  {
    field: "debtamount",
    headerName: "หนี้คงค้าง",
    width: 110,
    editable: false,
  },
  {
    field: "chqonhand",
    headerName: "เช็คในมือ",
    width: 110,
    editable: false,
  },
  {
    field: "chqreturn",
    headerName: "เช็คคืน",
    width: 110,
    editable: false,
  },
  {
    field: "CREDITLIMIT",
    headerName: "วงเงิน",
    width: 110,
    editable: false,
  },
];

export default function DataGridcsar(props) {
  const [openbackdrop, setopenbackdrop] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [Inputtext, setInputtext] = React.useState("");

  React.useEffect(() => {
    loadData("all");
    return () => {};
  }, []);
  const loadData = async (val) => {
    setopenbackdrop(true);
    let url = "";
    if (val === "all") {
      url = "CSAR/Getar_CSV_AR_SEARCH1?top=300";
    } else {
      url = `CSAR/Getar_CSV_AR_SEARCH1?top=100&type=${val}&text=${Inputtext}`;
    }
    //   await console.log("elementzzzzzzzzzzz", genURL(url));
    let rs = await axios.get(genURL(url), { timeout: 12000 });
    let element = [];
    // await console.log("elementzzzzzzzzzzz rs.data.length", rs);
    if (rs.data.length > 0) {
      // console.log("rs", rs.data);

      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          code: rs.data[index].code,
          arname: rs.data[index].arname,
          addressth: rs.data[index].addressth,
          contactname: rs.data[index].contactname,
          telephone: rs.data[index].telephone,
          debtamount: rs.data[index].debtamount,
          chqonhand: rs.data[index].chqonhand,
          chqreturn: rs.data[index].chqreturn,
          CREDITLIMIT: rs.data[index].CREDITLIMIT,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }

      // await setusedata(element)
      await setRows(element);
    } else {
      await setRows([]);
    }
    await setopenbackdrop(false);
  };

  const resData = (e) => {
    console.log("resData resData", e);
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = (e) => {
    props.Dataselect(e);
    // console.log("selcetRow", e)
  };
  const resinput = (e) => {
    setInputtext(e);
  };
  const keyDown = (e) => {
    console.log(e);
    if (e === "Enter") {
      loadData("search");
    }
  };
  return (
    <Box sx={{ height: 500, width: "100%" }}>
      <Stack direction="row" spacing={0} mt={1} mb={1}>
        <CustomInput
          label={"คำค้น"}
          resData={(e) => resinput(e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
        />

        <Button
          variant="outlined"
          startIcon={<SearchRoundedIcon />}
          sx={{
            pt: -5,
            height: "32px",
            mt: 1.4,
            borderColor: grayColor[11],
            color: blackColor[0],
            fontFamily: defaultFont,
          }}
          onClick={(e) => loadData("search")}
        >
          ค้นหา
        </Button>
      </Stack>

      {/* <Grid container spacing={2}>
                <Grid item xs={10}>
                    
                </Grid>
                <Grid item xs={2}>
                    xs=4
                </Grid>

            </Grid> */}

      {rows.length > 0 ? (
        <CustomDataGrid
          datacolumns={columns}
          datarows={rows}
          rowHeight={38}
          Dataintable={(e) => resData(e)}
          Dataintableremove={(e) => removeresData(e)}
          startRow={1}
          option={[{ add: false, del: false, select: true }]}
          checkboxSelection
          Dataselect={(e) => selcetRow(e)}
          RowsModelChange={(_) => console.log("RowsModelChange")}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} textAlign={"center"}>
            ไม่พบข้อมูล
          </Grid>
        </Grid>
      )}
      <CustomBackdrop open={openbackdrop} />
    </Box>
  );
}
